import { render, staticRenderFns } from "./ComponentGoodsSetup.vue?vue&type=template&id=16ae1f61"
import script from "./ComponentGoodsSetup.vue?vue&type=script&lang=js"
export * from "./ComponentGoodsSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports